import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const setAllocationMarine = async (
    marine_volume: any,
    construction_reserved_req: any,
    joint_fulfillment_out: any,
    construction_additional_req: any,
    construction_na_req: any
) => {
  const token = getToken();
  let valid = false;
  let result;
  const params = {
    marine_volume,
    construction_reserved_req,
    joint_fulfillment_out,
    construction_additional_req,
    construction_na_req
  };

  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/sustainability_reports/set_marine_allocation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(params),
        }
      );

      result = await response.json();
      valid = result && result.success;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (result && result.errors) {
      return {
        valid: false,
        message: result.errors,
      };
    }
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
  };
};

export default setAllocationMarine;
